import React, { useState, useEffect } from 'react'
import { initialiseSDK, getCreditCardForm } from 'services/tappay'
import { validateCard } from '../../services/tappay'


const TapPayForm = ({ 
    can_bind_card,
    display, 
    type = 'checkout', // or 'update'
    colour_theme,
    callback = null,
    cancelCallback = () => {},
    onBindCardSet,
    onTapPayCanGetPrime,
}) => {
    const [initialised, setInitialised] = useState(false);
    /** 
     * @typedef {number} CardStatus
     * 0: Valid
     * 1: Other fileld(s) empty
     * 2: Error
     * 3: Typing
     */
    const [cardStatus, setCardStatus] = useState({
        can_get_prime: false,
        number: 1,
        expiry: 1,
        ccv: 1,
    });
    const [bindCard, setBindCard] = useState(can_bind_card);
    const callbackUpdated = callback ?? onBindCardSet;

    useEffect(() => {
        // Initialize SDK
        const isInitialised = initialiseSDK();

        setInitialised(isInitialised);

        if (isInitialised && display === 'block') { getCreditCardForm(colour_theme); }
    }, [ display, colour_theme ]);

    useEffect(() => {
        // Validation handler
        validateCard((update) => {
            setCardStatus({ ...update });
            onTapPayCanGetPrime(update.can_get_prime);
        });
    }, [ onTapPayCanGetPrime ]);

    useEffect(() => {
        if (initialised && display === 'block') { getCreditCardForm(colour_theme); }
    }, [ initialised, display, colour_theme ]);

    useEffect(() => {
        setBindCard(can_bind_card);
    }, [ can_bind_card ]);

    useEffect(() => {
        if (!cardStatus.can_get_prime) { setBindCard(false); }
    }, [ cardStatus.can_get_prime ]);
    
    return (
        <div className={`tappay-form d-${display}`}>
            <div className='tpfield-container'>
                <label>信用卡號：</label>

                <div id='card-number' className='tpfield'/>
            
                {(cardStatus.number === 0) && <i className='invalid txt-green fa fa-check-circle'/>}

                {(cardStatus.number === 2) && <i className='invalid txt-red fa fa-times-circle'/>}
            </div>
        
            <div className='row'>
                <div className='tpfield-container col-sm-12 col-lg-6'>
                    <label>有效期限：</label>

                    <div id='card-expiration-date' className='tpfield'/>

                    {(cardStatus.expiry === 0) && <i className='invalid txt-green fa fa-check-circle'/>}

                    {(cardStatus.expiry === 2) && <i className='invalid txt-red fa fa-times-circle'/>}
                </div>

                <div className='tpfield-container col-sm-12 col-lg-6'>
                    <label>安全碼：</label>

                    <div id='card-ccv' className='tpfield'/>
                    {(cardStatus.ccv === 0) && <i className='invalid txt-green fa fa-check-circle'/>}

                    {(cardStatus.ccv === 2) && <i className='invalid txt-red fa fa-times-circle'/>}
                </div>
            </div>

            <div className='btn-container'>
                {type === 'update' && (
                    <button 
                        type='button' 
                        className='cancel ua-btn outline'
                        onClick={cancelCallback}
                    >
                        取消
                    </button>
                )}

                <button 
                    type='button' 
                    className={`ua-btn default ${!cardStatus.can_get_prime ? 'disabled' : ''}`}
                    disabled={!cardStatus.can_get_prime}
                    onClick={() => { callbackUpdated(!bindCard) }}
                >
                    {(can_bind_card && bindCard) ? '解除' : ''}{(type === 'checkout') ? '綁定' : '更新'}
                </button>
            </div>
        </div>
    );
};


export { TapPayForm }